const removeSpaces = (str?: string) => {
  if (!str) return ''

  return str.replace(/\s/g, '')
}

export default removeSpaces
